import { Integration } from '@futrli-sdk/app-store';
import { Organisation } from '@futrli-sdk/organisations';
import { API_PATHS, ROUTE_PARAMS, interpolatePathParams, getAxiosResponseData } from '@futrli/shared-services';

import { API_URL } from '../config';
import { makeRequestWithResponse } from './shared';

// override to allow predict url to point locally but keep this pointing to WSC
const OPTIONAL_BASE_URL = (API_URL && { baseURL: API_URL });

export const fetchIntegrations = async (): Promise<Integration[]> => {
  return getAxiosResponseData(
    await makeRequestWithResponse({
      ...OPTIONAL_BASE_URL,
      url: API_PATHS.INTEGRATIONS
    })
  );
};

export const fetchOrganisationById = async (workspaceId: string, organisationId: string): Promise<Organisation> => {
  return getAxiosResponseData(
    await makeRequestWithResponse({
      ...OPTIONAL_BASE_URL,
      url: interpolatePathParams(API_PATHS.ORGANISATION_BY_ID, {
        [ROUTE_PARAMS.ORGANISATION_ID]: organisationId,
        [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
      })
    })
  );
};
